import PropTypes from 'prop-types';
import React from 'react';
import ShowNav from './video_series/show_nav';
import VideoSeriesEntry from './video_series/video_series_entry';
import About from '../common/about';
import { isVideoSection } from '../../utils/sections';
import {find, drop, take, findIndex, flatMap, pull} from 'lodash';

const currentAndNextEpisode = (show, entryId) => {
  const episodes = flatMap(show.seasons, 'episodes');
  const currentEpisodeIndex = findIndex(episodes, ['id', entryId]);
  const upcomingEpisodes = drop(episodes, currentEpisodeIndex);
  return take(upcomingEpisodes, 2);
};

const VideoSeries = ({
  adsState, show, article,
  article: {
    id: entryId,
    sections: { body: [...sections] }
  },
  meta_title,
  meta_description,
  spotID,
  page_type
}) => {
  const [
    currentEpisode,
    nextEpisode = {}
  ] = currentAndNextEpisode(show, entryId);

  const currentSeason = find(
    show.seasons,
    ({ episodes }) => find(episodes, { id: entryId })
  );

  const videoSection = find(sections, isVideoSection);
  const textSections = pull(sections, videoSection);

  return (
    <div className="above-the-fold">
      <div className="video-series-container">
        <VideoSeriesEntry
          adsState={adsState}
          article={article}
          episode={currentEpisode}
          meta_title={meta_title}
          meta_description={meta_description}
          nextEpisode={nextEpisode}
          season={currentSeason}
          show={show}
          spotID={spotID}
          videoSection={videoSection}
          textSections={textSections}
        />
        <ShowNav entryId={entryId}
          seasons={show.seasons}
        />
      </div>
      {show.description &&
        <About
          about={show.description}
          title={show.display_name}
          page_type={page_type}
        />
      }
    </div>
  );
};

VideoSeries.propTypes = {
  adsState: PropTypes.object.isRequired,
  article: PropTypes.shape({
    id: PropTypes.number.isRequired,
    sections: PropTypes.shape({
      body: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string.isRequired,
          content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
          ]).isRequired
        }).isRequired
      ).isRequired
    }).isRequired
  }).isRequired,
  meta_title: PropTypes.string.isRequired,
  meta_description: PropTypes.string.isRequired,
  show: PropTypes.shape({
    description: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
    seasons: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  spotID: PropTypes.string,
  page_type: PropTypes.string
};

export default VideoSeries;
